export const typography = {
  fontFamily: [
    '"Open Sans"',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  h1: {
    fontWeight: 300,
  },
  h2: {
    fontWeight: 300,
  },
  h3: {
    fontWeight: 400,
  },
  h4: {
    fontWeight: 400,
  },
  h5: {
    fontWeight: 400,
  },
  h6: {
    fontWeight: 400,
  },
  subtitle1: {
    fontSize: 18,
  },
  subtitle2: {
    fontWeight: 600,
  },
  overline: {
    fontWeight: 700,
    fontStyle: 'italic',
    letterSpacing: 2,
  },
  button: {
    fontWeight: 600,
  },
};
